export const CARDAPIO_TIMEZONE = 'America/Sao_Paulo';

export const DEFAULT_AVAILABILITY_RULE = {
  dias: [1, 2, 3, 4, 5],
  inicio: '09:00',
  fim: '18:00',
};

const WEEKDAY_INDEX = {
  Sun: 0,
  Mon: 1,
  Tue: 2,
  Wed: 3,
  Thu: 4,
  Fri: 5,
  Sat: 6,
};

const toMinutes = (value) => {
  if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(String(value || ''))) return null;
  const [hours, minutes] = String(value).split(':').map(Number);
  return (hours * 60) + minutes;
};

export const getZonedDayAndMinutes = (
  date = new Date(),
  timeZone = CARDAPIO_TIMEZONE
) => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(date);
  const values = Object.fromEntries(parts.map(({ type, value }) => [type, value]));

  return {
    day: WEEKDAY_INDEX[values.weekday],
    minutes: (Number(values.hour) * 60) + Number(values.minute),
  };
};

export const isAvailabilityRuleActive = (rule, day, minutes) => {
  const days = Array.isArray(rule?.dias) ? rule.dias : [];
  const start = toMinutes(rule?.inicio);
  const end = toMinutes(rule?.fim);
  if (!Number.isInteger(day) || start == null || end == null || start === end) return false;

  if (start < end) {
    return days.includes(day) && minutes >= start && minutes < end;
  }

  const previousDay = (day + 6) % 7;
  return (days.includes(day) && minutes >= start)
    || (days.includes(previousDay) && minutes < end);
};

export const isCardapioAvailable = (
  cardapio,
  date = new Date(),
  timeZone = CARDAPIO_TIMEZONE
) => {
  const availability = cardapio?.disponibilidade;
  if (!availability?.enabled) return true;

  const rules = Array.isArray(availability.regras) ? availability.regras : [];
  if (!rules.length) return false;

  const { day, minutes } = getZonedDayAndMinutes(date, timeZone);
  return rules.some((rule) => isAvailabilityRuleActive(rule, day, minutes));
};

export const buildAvailabilityForm = (availability) => ({
  enabled: availability?.enabled === true,
  regras: Array.isArray(availability?.regras) && availability.regras.length
    ? availability.regras.map((rule) => ({
        dias: Array.isArray(rule?.dias) ? [...rule.dias] : [],
        inicio: rule?.inicio || '',
        fim: rule?.fim || '',
      }))
    : [{ ...DEFAULT_AVAILABILITY_RULE, dias: [...DEFAULT_AVAILABILITY_RULE.dias] }],
  mostrarForaDoHorario: availability?.mostrarForaDoHorario !== false,
});

export const validateAvailabilityForm = (availability) => {
  if (!availability?.enabled) return null;
  const rules = Array.isArray(availability.regras) ? availability.regras : [];
  if (!rules.length) return 'Adicione pelo menos uma faixa de horário.';

  for (const rule of rules) {
    if (!Array.isArray(rule?.dias) || !rule.dias.length) {
      return 'Selecione ao menos um dia em cada faixa de horário.';
    }
    const start = toMinutes(rule.inicio);
    const end = toMinutes(rule.fim);
    if (start == null || end == null) return 'Informe horários válidos.';
    if (start === end) return 'O início e o fim da faixa não podem ser iguais.';
  }

  return null;
};
